<template>
  <div class="componentRoot" v-if="dailyData">
    <v-card flat class="mt-4">
      <v-container fluid>
        <v-row>
          <v-col>
            <h2>{{ $t("messages.welcomeBack", { name: $store.state.name }) }}</h2>
          </v-col>
        </v-row>
      </v-container>
    </v-card>

    <v-container fluid class="mt-2">
      <v-row v-if="visibleNotifications.length !== 0">
        <v-col>
          <v-card class="" flat>
            <v-container fluid>
              <v-row>
                <v-col>
                  <h3><v-icon>mdi-bell-outline</v-icon> {{ $t("basics.notifications") }}</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col :cols="billCols" v-for="n in visibleNotifications">
                  <v-card v-if="n.type == 'time_slot'" flat class="background-background"
                   >
                    <v-container fluid>
                      <v-row>
                        <v-col cols="auto" style="display: flex; align-items: center;">
                          <v-icon color="primary" class="regular-transparency">mdi-circle</v-icon>
                        </v-col>
                        <v-col cols="auto">
                          {{ $t("basics.appointmentReminder") }}<br>
                          {{ n.item.display_date }}, {{ n.item.time_units[0].readable_start_time }} -
                          {{ n.item.time_units[n.item.time_units.length - 1].readable_end_time }} {{ $t("basics.oClock")
                          }}
                        </v-col>
                        <v-spacer />
                        <v-col cols="auto" style="display: flex; align-items: center;"  @click="getICSFile($event, n.item, false)">
                          <v-tooltip :text="$t('messages.openInNewTab')">
                            <template v-slot:activator="{ props }">
                              <v-icon v-if="!downloaded" color="primary" size="x-large" class="mr-4 regular-transparency"
                                v-bind="props">mdi-download</v-icon>
                              <v-icon v-else color="primary" size="x-large" class="mr-4 regular-transparency"
                                v-bind="props">mdi-check</v-icon>
                            </template>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                  <v-card v-if="n.type == 'bill'" flat class="background-background"
                    @click="getBillFile($event, n.item, true)">
                    <v-container fluid>
                      <v-row>
                        <v-col cols="auto" style="display: flex; align-items: center;">
                          <v-icon class="icon-transparency">mdi-circle</v-icon>
                        </v-col>
                        <v-col cols="auto">
                          {{ $t("messages.newBillForPatient") }}<br>
                          {{ n.item.total_sum }}€, {{ $t("basics.dueDate") }}: {{ n.item.display_due_date }}
                        </v-col>
                        <v-spacer />
                        <v-col cols="auto" style="display: flex; align-items: center;">
                          <v-tooltip :text="$t('messages.openInNewTab')" v-if="n.item.has_file">
                            <template v-slot:activator="{ props }">
                              <v-icon color="primary" size="x-large" class="mr-4 regular-transparency"
                                v-bind="props">mdi-download</v-icon>
                            </template>
                          </v-tooltip>
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-card>
                </v-col>
              </v-row>
              <v-row v-if="visibleNotifications.length === 0">
                <v-col>
                  <p><i>{{ $t("messages.noItems") }}</i></p>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid class="mt-2">
      <v-row>
        <v-col>
          <v-card class="" flat>
            <v-container fluid>
              <v-row>
                <v-col>
                  <h3><v-icon size="x-large">mdi-calendar-account</v-icon> {{ $t("messages.nextAppointments") }}</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-for="ts in visibleTimeSlots" :cols="cardCols"
                  style="display: flex; flex-direction: column;">
                  <AppointmentCardVue style="height: 100%" :appointmentData="ts" :profileView="true" @refetch="fetchProfileData" />
                </v-col>
                <v-col v-if="visibleTimeSlots.length === 0" cols="12" style="display: flex; flex-direction: column;">
                  <v-card class="pa-4" flat>
                    <p><i>{{ $t("messages.noItems") }}</i></p>
                  </v-card>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>


    <v-container fluid class="mt-2" v-if="visibleRequests.length !== 0">
      <v-row>
        <v-col>
          <v-card class="" flat>
            <v-container fluid>
              <v-row>
                <v-col>
                  <h3><v-icon size="x-large">mdi-calendar-question</v-icon> {{ $t("messages.appointmentRequest") }}</h3>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-for="ts in visibleRequests" :cols="cardCols"
                  style="display: flex; flex-direction: column;">
                  <AppointmentCardVue :appointmentData="ts" :profileView="true" 
                  
                  @refetch="fetchProfileData" :disableDownload="true" />
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!--  <v-container fluid  class="mt-2">
      <v-row>
        <v-col cols="12">
          <v-card class="pa-4" flat>
           <TimeTableParentVue :startDate="activeDate" :readonly="false" :profileView="true"
              fetchURL="calendar/calendar/profile/" />
          </v-card>
        </v-col>
      </v-row>
    </v-container> -->

    <v-container fluid class="mt-2">
      <v-row>
        <v-col>
          <v-card class="" flat>
            <v-container fluid>
              <v-row>
                <v-col cols="auto">
                  <h3><v-icon size="x-large">mdi-calendar-plus</v-icon> {{ $t("messages.requestApppointment") }}</h3>
                </v-col>

                <v-col v-if="!appointmentBookingData">
                  <v-progress-circular color="primary" indeterminate></v-progress-circular>
                </v-col>
                <v-spacer />
                <v-col cols="auto" v-if="dailyData && dailyData.therapists && dailyData.therapists.length > 1">
                  <v-select :items="dailyData.therapists" v-model="therapist" return-object item-title="full_name"
                    item-value="full_name" variant="outlined" density="compact" flat></v-select>
                </v-col>
              </v-row>

              <v-row v-if="appointmentBookingData && appointmentBookingData.can_request">
                <!-- <v-col cols="12">
                  <v-sheet class="d-flex" tile>
                    <v-btn class="ma-2" variant="text" icon @click="$refs.calendar.prev()">
                      <v-icon>mdi-chevron-left</v-icon>
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn class="ma-2" variant="text" icon @click="$refs.calendar.next()">
                      <v-icon>mdi-chevron-right</v-icon>
                    </v-btn>
                  </v-sheet>
                  <v-sheet height="600">
                    <v-calendar ref="calendar" locale="de" v-model="focus" type="month" color="primary"
                      :weekdays="isMobile ? [1, 2, 3, 4, 5] : [1, 2, 3, 4, 5, 6, 0]">
                      <template #day="{ day, date }">
                        <div @click="onDateClick(date)" class="v-calendar-day"
                          style="position: absolute; height: 100%; width: 100%; z-index: 2">

                          <div
                            style="width: 100%; height: 10px; display: flex; justify-content: center; position: absolute; bottom: 0;"
                            class="mt-1">
                            <v-icon v-if="hasEvent(date)" color="primary" size="xx-small">mdi-circle</v-icon>
                          </div>
                        </div>
                      </template>
                    </v-calendar>
                  </v-sheet>
                </v-col> -->

                <v-col :cols="12">
                  <v-expansion-panels flat variant="accordion" v-model="panels" :multiple="true">
                    <v-expansion-panel v-for="date in appointmentBookingData.dates" :id="'day_' + date.date">
                      <v-expansion-panel-title>
                        <div style="display: flex; justify-content: space-between; width: 100%;">
                          <h3>
                            {{ date.display_date }}
                          </h3>
                        </div>
                      </v-expansion-panel-title>
                      <v-expansion-panel-text>
                        <div v-for="aa in availAppointments(date)" class="py-2 hoverable"
                          @click="showRequestAppointment(date, aa)">
                          <v-icon class="icon-transparency" style="margin-top: -2px">mdi-plus</v-icon>
                          {{ aa.start.display_start_time }} - {{ aa.end.display_end_time }}
                        </div>
                      </v-expansion-panel-text>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
              </v-row>

              <v-row v-else>
                <v-col>
                  {{$t("messages.maxRequestsReached")}}
                </v-col>
              </v-row>

            </v-container>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <AppointmentRequestDrawerVue :refreshDisplay="appointmentRequestDrawer" :slotData="slotData" :therapist="therapist"
      @close="closeAppointmentRequestDrawer" />
    <AppointmentRequestDeletionDrawerVue :refreshDisplay="requestDeletionWarningDrawer" :slotData="activeRequest"
      @close="closeAppointmentDeletionDrawer" />

    <v-snackbar v-model="requestSentSnackbar" color="primary" :timeout="2000" location="bottom right">
      <v-icon size="xx-large">mdi-check-all</v-icon>
      <h3>{{ $t("messages.requestSent") }}!</h3>
    </v-snackbar>
  </div>
</template>

<script>
import { Capacitor } from '@capacitor/core';
import { Share } from '@capacitor/share';
import { Filesystem, Directory, Encoding } from "@capacitor/filesystem";

// import TimeTableParentVue from "../../components/calendar/TimeTableParent.vue";
import AppointmentCardVue from '../../components/calendar/AppointmentCard.vue';
import AppointmentRequestDrawerVue from '../../components/calendar/AppointmentRequestDrawer.vue';
import AppointmentRequestDeletionDrawerVue from '../../components/calendar/AppointmentRequestDeletionDrawer.vue';


export default {
  name: "dashboard",

  data() {
    return {
      dailyData: undefined,
      displayDate: this.$moment(new Date()).format("DD.MM.YYYY"),
      weekday: new Date().getDay(),

      appointmentBookingData: undefined,

      panels: [],

      loading: false,
      refreshTimeTable: 0,
      activeDate: new Date(),

      focus: new Date(),
      selectedDate: null,

      appointmentRequestDrawer: 0,
      therapist: undefined,
      slotData: undefined,

      requestSentSnackbar: false,
      downloaded: false,

      activeRequest: undefined,
      requestDeletionWarningDrawer: 0
    };
  },


  components: {
    AppointmentCardVue,
    // TimeTableParentVue
    AppointmentRequestDrawerVue,
    AppointmentRequestDeletionDrawerVue
  },

  computed: {
    visibleTimeSlots() {
      return (this.dailyData?.time_slots || []).filter(this.canDisplayAppointment);
    },
    visibleRequests() {
      return (this.dailyData?.requests || []).filter(this.canDisplayAppointment);
    },
    visibleNotifications() {
      return (this.dailyData?.notifications || []).filter(notification =>
        notification.type !== 'time_slot' || this.canDisplayAppointment(notification.item));
    },
    maxDays() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 1;
        case "sm":
          return 1;
        default:
          return this.appointmentBookingData ? this.appointmentBookingData.max_future_days : 5;
        // case "md":
        //   return 2
        // case "lg":
        //   return 5;
        // case "xl":
        //   return 5;
        // case "xxl":
        //   return 5;
        // default:
        //   return 5;
      }
    },
    eventDates() {
      if (!this.appointmentBookingData) return new Set()

      const set = new Set()

      this.appointmentBookingData.dates.forEach(d => {
        if (d.free_rooms?.length > 0) {
          set.add(d.date)
        }
      })

      return set
    },
    mainCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 12;
        case "lg":
          return 8;
        case "xl":
          return 8;
        case "xxl":
          return 8;
        default:
          return 8;
      }
    },
    billCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 12;
        case "lg":
          return 6;
        case "xl":
          return 4;
        case "xxl":
          return 4;
        default:
          return 8;
      }
    },
    actionCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 12;
        case "md":
          return 6;
        case "lg":
          return 6;
        case "xl":
          return 6;
        case "xxl":
          return 6;
        default:
          return 6;
      }
    },
    cardCols() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return 12;
        case "sm":
          return 6;
        case "md":
          return 6;
        case "lg":
          return 4;
        case "xl":
          return 4;
        case "xxl":
          return 4;
        default:
          return 4;
      }
    },
    isMobile() {
      switch (this.$vuetify.display.name) {
        case "xs":
          return true;
        case "sm":
          return true;
        case "md":
          return false;
        case "lg":
          return false;
        case "xl":
          return false;
        case "xxl":
          return false;
        default:
          return false;
      }
    },
  },

  methods: {
    canDisplayAppointment(slot) {
      if (!slot || slot.own_booking?.is_cancelled === true ||
          (slot.display_status && slot.display_status !== 'planned')) return false;
      return slot.public !== true || slot.own_booking?.is_paid === true;
    },
    closeAppointmentRequestDrawer(data) {
      this.appointmentRequestDrawer = 0

      if (data) {
        this.fetchData()

        this.requestSentSnackbar = true
      }
    },
    closeAppointmentDeletionDrawer(data) {
      this.requestDeletionWarningDrawer = 0

      if (data) {
        this.fetchData()
      }
    },
    showRequestAppointment(date, availSlot) {
      this.slotData = {
        date: date.date,
        display_date: date.display_date,
        display_start_time: availSlot.start.display_start_time,
        display_end_time: availSlot.end.display_end_time,
        start_time: availSlot.start.start_time,
        end_time: availSlot.end.end_time,
      }

      ++this.appointmentRequestDrawer
    },
    availAppointments(date) {
      if (!date?.free_rooms) {
        return []
      }

      const result = []

      for (let i = 0; i < date.free_rooms.length - 1; i++) {
        const current = date.free_rooms[i]
        const next = date.free_rooms[i + 1]

        // Nur wenn die Slots direkt aneinander anschließen
        if (current.end_time === next.start_time) {
          result.push({
            start: current,
            end: next
          })
        }
      }

      return result
    },
    hasEvent(date) {
      return this.eventDates.has(date)
    },
    onDateClick(date) {
      if (!this.hasEvent(date)) {
        return
      }

      if (!this.appointmentBookingData || !this.appointmentBookingData.dates) {
        return
      }

      for (let i = 0; i < this.appointmentBookingData.dates.length; i++) {
        if (this.appointmentBookingData.dates[i].date == date) {
          if (this.panels.indexOf(i) < 0) {
            this.panels.push(i)
          }
        }
      }

      setTimeout(() => {
        const el = document.getElementById("day_" + date)

        if (!el) return

        const y = el.getBoundingClientRect().top + window.pageYOffset

        window.scrollTo({
          top: y - 64,
          behavior: "smooth"
        })
      }, 300)
    },
    getBillFile(event, bill, newTab) {
      event.stopPropagation();
      event.preventDefault();

      if (bill.blob) {
        this.openFile(bill, newTab)
      }
      else {
        this.axios({
          method: "POST",
          url: this.axios.defaults.baseURL + "user/bills/file/profile/",
          responseType: "blob", // Important! Set the response type to 'blob' for binary data
          data: {
            id: bill.id,
          },
        })
          .then((resp) => {
            bill.blob = URL.createObjectURL(resp.data);

            const contentDisposition = resp.headers["content-disposition"];
            const filenameMatch = /filename=([^"]+)/.exec(contentDisposition);
            bill.filename = filenameMatch[1]

            this.openFile(bill, newTab)
          })
          .catch((e) => {
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          });
      }
    },
    getICSFile(event, timeSlot, newTab) {
      event.stopPropagation();
      event.preventDefault();

      if (timeSlot.blob) {
        this.openFile(timeSlot, newTab)
      }
      else {
        this.axios({
          method: "POST",
          url: this.axios.defaults.baseURL + "calendar/ical/icsfile/",
          responseType: "blob", // Important! Set the response type to 'blob' for binary data
          data: {
            id: timeSlot.id,
          },
        })
          .then(async (resp) => {            
            if (Capacitor.isNativePlatform()) {
              const contentDisposition = resp.headers?.["content-disposition"] || "";
              const match = /filename="?([^"]+)"?/.exec(contentDisposition);
              const filename = match?.[1] || `Termin-${timeSlot.date}.ics`;
              const icsText = typeof resp.data === "string" ? resp.data : String(resp.data ?? "");
              
              const path = `Keilberg/${filename}`;

              const isIOS = Capacitor.getPlatform() == 'ios'

              await Filesystem.writeFile({
                directory: isIOS ? Directory.Cache : Directory.Documents,
                path: path,
                recursive: true,
                data: icsText,
                encoding: Encoding.UTF8
              });

              if(isIOS){
              const uriResult = await Filesystem.getUri({ directory: isIOS ? Directory.Cache : Directory.Documents, path: path });
              
              await Share.share({
                  url: uriResult.uri,
                  title: "Datei teilen oder speichern",
                  dialogTitle: "Datei teilen oder speichern",
                })
              } else {
                // android not possible to choose custom download location
                this.downloaded = true
                setTimeout(()=>{
                  this.downloaded = false
                }, 3000)
              }
            } 
            else{
              timeSlot.blob = URL.createObjectURL(resp.data);

              const contentDisposition = resp.headers["content-disposition"];
              const filenameMatch = /filename=([^"]+)/.exec(contentDisposition);
              timeSlot.filename = filenameMatch[filenameMatch.length-1]
    
              this.openFile(timeSlot, newTab)
            }

          })
          .catch((e) => {
            console.log(e);
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }));
          });
      }
    },
    openFile(bill, newTab) {
      if (newTab) {
        window.open(bill.blob, "_blank");
      } else {
        const a = document.createElement("a");
        console.log(bill)
        a.href = bill.blob;
        a.download = bill.filename;
        document.body.appendChild(a);
        a.click();
      }
    },
    fetchData() {
      this.loading = true

      this.fetchProfileData().then(() => {
        this.fetchAppointmentBookingData().then(() => {
          this.loading = false
        })
      })
    },
    showDeleteRequest(event, timeSlot){
      event.stopPropagation()
      event.preventDefault()

      this.activeRequest = timeSlot
      setTimeout(() => {
        this.requestDeletionWarningDrawer++
      }, 200);
    },
    fetchProfileData() {
      return new Promise((resolve, reject) => {
        this.axios.post(this.axios.defaults.baseURL + "user/profile/", {
          date: this.today
        })
          .then((resp) => {
            this.dailyData = resp.data
            this.therapist = this.dailyData.therapists[0]
            resolve()
          })
          .catch((e) => {
            console.log(e)
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }))
            reject()
          })
      })
    },
    fetchAppointmentBookingData() {
      return new Promise((resolve, reject) => {
        this.axios.post(this.axios.defaults.baseURL + "calendar/calendar/profile/", {
          date: this.today,
          days: this.maxDays,
          therapist: this.therapist.id
        })
          .then((resp) => {
            this.appointmentBookingData = resp.data
            resolve()
          })
          .catch((e) => {
            console.log(e)
            window.dispatchEvent(new CustomEvent("showErrorDisplay", { detail: e }))
            reject()
          })
      })
    },
  },

  mounted() {
    this.fetchData()
  },
};
</script>
